var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errorMessageList.length
    ? _c("div", { staticClass: "errorArea" }, [
        _vm.isToBeError(_vm.resultCode)
          ? _c(
              "div",
              [
                _vm._l(_vm.errorMessageList, function (errorMessage) {
                  return _c("p", {
                    key: errorMessage,
                    staticClass: "errorMessage__toB",
                    domProps: { innerHTML: _vm._s(errorMessage) },
                  })
                }),
                _vm._v(" "),
                _c("p", { staticClass: "errorMessage__noEmail" }, [
                  _vm._v("別のメールアドレスをお持ちでない場合"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "errorMessage__linkWrapper" }, [
                  _c(
                    "a",
                    {
                      staticClass: "errorMessage__createAccountLink",
                      attrs: {
                        href: "/rnet/info/notice/index02.html",
                        target: "_blank",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sendLoginClickLog($event)
                        },
                      },
                    },
                    [_vm._v("新規作成方法はこちら\n      ")]
                  ),
                ]),
              ],
              2
            )
          : _c(
              "div",
              _vm._l(_vm.errorMessageList, function (errorMessage) {
                return _c(
                  "p",
                  { key: errorMessage, staticClass: "errorMessage" },
                  [_vm._v(_vm._s(errorMessage))]
                )
              }),
              0
            ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }